import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "screen screen-overlay" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "The End", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Thanks for playing!", -1)
const _hoisted_5 = { class: "results" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Results", -1)
const _hoisted_7 = { class: "leaderboard" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Top Participants:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("ol", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats.topPlayers, (player) => {
              return (_openBlock(), _createElementBlock("li", {
                key: player.id
              }, _toDisplayString(player.name) + " - " + _toDisplayString(player.score) + " points ", 1))
            }), 128))
          ])
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.stats.scenariosPlayed) + " Questions Discussed", 1)
      ])
    ]),
    _createElementVNode("button", {
      class: "btn-link action-right",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.invokeAction && _ctx.invokeAction(...args)))
    }, " New Game ")
  ]))
}